<div class="home-page page">
    <main class="home-page__content content">

        <header class="home-page__header">
            <div class="page-title">Hi User,</div>
            <div class="page-subtitle">Welcome back to <strong>ECHO</strong> API Services</div>
        </header>

        <section class="home-page__section-content">
            <div class="home-page__section-title">What is Deloitte ECHO?</div>

            <p>
                ECHO API Simulation helps you unlock true parallel development by simulating your APIs. Whether you're
                an architect, analyst, developer, or tester, our platform enables you to:
            </p>

            <ul>
                <li>Upload OpenAPI specifications to instantly generate simulated endpoints</li>
                <li>Test and validate front-end code in isolation</li>
                <li>Configure multi-step scenarios and dynamic responses</li>
                <li>Create, manage, and monitor services directly from this portal</li>
            </ul>

            <p>
                ECHO API Simulation is powered by Large Language Models to provide context-aware, evolving mock
                responses. It's not just static test data: it learns, it adjusts, and it mirrors real integration
                workflows.
                <br /><br />
                Use the menu to:
            </p>

            <ul>
                <li>Set up new projects</li>
                <li>Upload your API specification files</li>
                <li>Create services and understand how to use them in your work</li>
            </ul>

            <p>
                By using ECHO API Simulation, you reduce rework, align teams early, and accelerate delivery.
                <br />
                Let's simulate smarter.
            </p>
        </section>

    </main>
</div>